import { render, staticRenderFns } from "./TrustedPartnersList.vue?vue&type=template&id=45e29c34&"
import script from "./TrustedPartnersList.vue?vue&type=script&lang=js&"
export * from "./TrustedPartnersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports